import React from "react";
import {  StyledH2, StyledLabel } from "@aureskonnect/react-ui";
import { useTranslation } from "react-i18next";
import { Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import { useSnapshot } from "valtio";
import { store as device } from "../../../../components/VerticalLayout/store";
import { capitalize } from "@helpers/general";
import { CustomSecondaryColorButton } from "@components/Common/CustomSecondaryColorButton";
import { showSuccessToast } from "@components/Common/SuccessToast";
import { CustomMainColorButton } from "@components/Common/CustomMainColorButton";
import ErrorToast from "@components/Common/ErrorTost";
import { useFetchGlobal } from "../../../../api/hooks";

import { dissociateDevice } from "./api";

type PrintersPathsModalType = {
    setIsDeviceDissociateModalOpened: (value: boolean) => void;
    isDeviceDissociateModalOpened: boolean;
    selectedRows: Record<string, any>[];
    setDataIsUpdated: (value: boolean) => void;
};

export default function DeviceDissociateModal({
    setIsDeviceDissociateModalOpened,
    isDeviceDissociateModalOpened,
    selectedRows,
    setDataIsUpdated,
}: PrintersPathsModalType) {
    const { t } = useTranslation();
    const { fetchGlobal } = useFetchGlobal();
    const { oneShop, userID, shopID, franchiseID, operatorID } = useSnapshot(
        device
    );

    async function handleDissociate() {
        if (!selectedRows[0]) return;

        try {
            const result: any = await dissociateDevice(fetchGlobal, {
                userID,
                franchiseID,
                operatorID,
                oneShop,
                shopID: shopID.toString(),
                selectedRow: selectedRows[0],
            });
            if (result.error) {
                throw Error("error");
            }
            showSuccessToast(
                `${t(
                    "Unpairing of this device has been successfully completed"
                )!}`
            );
            setIsDeviceDissociateModalOpened!(!isDeviceDissociateModalOpened);
            setDataIsUpdated!(true);
        } catch (e) {
            ErrorToast(`${t("There's an error")!}`);
        }
    }

    return (
        <React.Fragment>
            <Modal
                centered
                isOpen={isDeviceDissociateModalOpened}
                className="cmn_frm_alertDissociation"
            >
                <ModalHeader
                    toggle={() => {
                        setIsDeviceDissociateModalOpened!(
                            !isDeviceDissociateModalOpened
                        );
                    }}
                >
                    <StyledH2>{capitalize(t("Alert"))}</StyledH2>
                </ModalHeader>
                <ModalBody>
                    <StyledLabel className="pl-3 m-0">
                        {t("Please confirm unpairing this device")}
                    </StyledLabel>
                </ModalBody>
                <ModalFooter className="border-top-0">
                    <CustomSecondaryColorButton
                        outline
                        variant="light"
                        onClick={() => {
                            setIsDeviceDissociateModalOpened!(
                                !isDeviceDissociateModalOpened
                            );
                        }}
                        rounded
                        className="afa_btn_cancelAlert"
                    >
                        {t("Cancel")}
                    </CustomSecondaryColorButton>
                    <CustomMainColorButton
                        rounded
                        className="cmn_btn_validateAlert mr-2"
                        variant="primary"
                        onClick={handleDissociate}
                    >
                        {t("Validate")}
                    </CustomMainColorButton>
                </ModalFooter>
            </Modal>
        </React.Fragment>
    );
}
